<p-confirmDialog key="modifyschedule" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Options-->
<div class="ItemBorder">
	<div class="MainItemDiv">
		<label>Job Name:</label>
		<label style="color: blue">{{ JobDesc }}</label>

		<label *ngIf="EditMode == true" for="Active">Active:</label>
		<input *ngIf="EditMode == true" [disabled]="IsLoading() == true" id="Active" type="checkbox" class="CHK" [(ngModel)]="Active" />

		<label>Time:</label>
		<p-calendar
			[disabled]="IsLoading() == true"
			showIcon="true"
			showButtonBar="true"
			timeOnly="true"
			showTime="true"
			hourFormat="12"
			[(ngModel)]="RunTime"
			name="RunTime"
			appendTo="body"
		></p-calendar>

		<label>Days:</label>
		<table class="WeekTable">
			<tr>
				<th><label for="RunMon">Monday</label></th>
				<th><label for="RunTue">Tuesday</label></th>
				<th><label for="RunWed">Wednesday</label></th>
				<th><label for="RunThu">Thursday</label></th>
				<th><label for="RunFri">Friday</label></th>
				<th><label for="RunSat">Saturday</label></th>
				<th><label for="RunSun">Sunday</label></th>
			</tr>
			<tr>
				<td><input [disabled]="IsLoading() == true" id="RunMon" type="checkbox" class="CHK" [(ngModel)]="RunMon" /></td>
				<td><input [disabled]="IsLoading() == true" id="RunTue" type="checkbox" class="CHK" [(ngModel)]="RunTue" /></td>
				<td><input [disabled]="IsLoading() == true" id="RunWed" type="checkbox" class="CHK" [(ngModel)]="RunWed" /></td>
				<td><input [disabled]="IsLoading() == true" id="RunThu" type="checkbox" class="CHK" [(ngModel)]="RunThu" /></td>
				<td><input [disabled]="IsLoading() == true" id="RunFri" type="checkbox" class="CHK" [(ngModel)]="RunFri" /></td>
				<td><input [disabled]="IsLoading() == true" id="RunSat" type="checkbox" class="CHK" [(ngModel)]="RunSat" /></td>
				<td><input [disabled]="IsLoading() == true" id="RunSun" type="checkbox" class="CHK" [(ngModel)]="RunSun" /></td>
			</tr>
		</table>
	</div>
</div>

<div class="Buttons">
	<button *ngIf="EditMode == false" class="btn btn-primary" (click)="onAdd()">Add</button>
	<button *ngIf="EditMode == true" class="btn btn-primary" (click)="onUpdate()">Update</button>
	<button class="btn btn-warning" (click)="onClose()">Cancel</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
</div>
